<form (ngSubmit)="postJobDescription()" [formGroup]="jobPositionDescriptionForm">
  <div class="row col-md-12" *ngIf="!isSimplify">
    <h5 class="sub-title">Position Details</h5>
  </div>
  <div class="row col-md-12 pl-0 mb-3">
    <div class="col-md-4 form-group input-disabled">
      <label class="label-cls positionTitle required"> Position Title </label>
      <input class="im-input mw-100" [readonly]="disabledControls" formControlName="jobTitle" type="text" pInputText
        placeholder="Enter" />
      <div *ngIf="jobPositionDescriptionForm.controls['jobTitle'].touched && jobPositionDescriptionForm.controls['jobTitle'].invalid">
        <span class="invalid-message" *ngIf="jobPositionDescriptionForm.controls['jobTitle'].errors?.required">
          {{getGlobalErrorMessages('REQUIRED')}}
        </span>
      </div>
    </div>
  </div>
  <div class="row col-md-12 mb-3 p-0" id="cusomJobdate">
    <div class="col-md-4 form-group">
      <label class="label-cls row required"> Start Date </label><br>
      <p-calendar id="startDate" yearRange="1900:2100" appendTo="body" type="text" class="mw-100" yearNavigator="true"
        monthNavigator="true" formControlName="startDate" showIcon="true" showButtonBar="true"
        [disabled]="disabledControls" inputId="icon" [showIcon]="true" dateFormat="mm/dd/yy" placeholder="MM/DD/YY"
        name="startDate">
      </p-calendar>
      <div *ngIf="jobPositionDescriptionForm.controls['startDate'].touched && jobPositionDescriptionForm.controls['startDate'].invalid">
        <span class="invalid-message" *ngIf="jobPositionDescriptionForm.controls['startDate'].errors?.required">
          {{getGlobalErrorMessages('REQUIRED')}}
        </span>
      </div>
    </div>
    <div class="col-md-5 form-group input-disabled">
      <label class="row label-cls  required"> End Date </label><br>
      <p-calendar yearRange="1900:2100" id="endDate" appendTo="body" type="text" class="mw-100"
        formControlName="endDate" yearNavigator="true" monthNavigator="true" showIcon="true" showButtonBar="true"
        [disabled]="disabledControls" inputId="icon" [showIcon]="true" dateFormat="mm/dd/yy" placeholder="MM/DD/YY"
        name="endDate">
      </p-calendar>
      <div *ngIf="jobPositionDescriptionForm.controls['endDate'].touched && jobPositionDescriptionForm.controls['endDate'].invalid">
        <span class="invalid-message" *ngIf="jobPositionDescriptionForm.controls['endDate'].errors?.required">
          {{getGlobalErrorMessages('REQUIRED')}}
        </span>
      </div>
      <div *ngIf="jobPositionDescriptionForm.controls['endDate'].errors?.positionDateValidation">
        <span class="invalid-message">
          End date should be greater than or equal to Start Date
        </span>
      </div>
    </div>
  </div>
  <div class="row col-md-12 p-0">
    <div class="col-md-12 p-0 form-group">
      <div class="row col-md-6">
        <div class="col-md-11 pl-0 bold-label" name="question">
          <label class="label-cls">Is this a full time position?</label>
        </div>
        <div class="col-md-1">
          <p-inputSwitch id="thisFulltime" class="swtBtn" [disabled]="disabledControls" value="thisFulltime"
            formControlName="thisFulltime">
          </p-inputSwitch>
        </div>
      </div>
      <div class="row" *ngIf="jobPositionDescriptionForm.get('thisFulltime').value === false">
        <div class="col-md-4 form-group input-disabled">
          <label class="label-cls workingHr required"> Working Hours per week </label>
          <input [readonly]="disabledControls" type="text" class="im-input mw-100" id="workingHoursPerWeek"
            formControlName="workingHoursPerWeek" placeholder="Enter" pattern="\d{1,5}" pInputText />
          <div
            *ngIf="jobPositionDescriptionForm.get('workingHoursPerWeek').touched && jobPositionDescriptionForm.get('workingHoursPerWeek').invalid">
            <span class="invalid-message" *ngIf="jobPositionDescriptionForm.get('workingHoursPerWeek').errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
            <span class="invalid-message" *ngIf="jobPositionDescriptionForm.get('workingHoursPerWeek').errors?.pattern">
              {{getGlobalErrorMessages('NUMBER_ONLY')}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row col-md-12">
    <h5 class="sub-title">Wage offer Information</h5>
  </div>
  <div class="row col-md-12 p-0 mb-3">
    <div class="col-md-4 form-group input-disabled">
      <label class="label-cls required"> Wage </label>
      <span class="p-input-icon-left mask-input mw-100"> <i class="pi pi-dollar"></i>
        <input class="im-input mask-in mw-100" id="wagesFrom" formControlName="wagesFrom" type="text"
          [readonly]="disabledControls" pInputText placeholder="" /> </span>
      <div *ngIf="jobPositionDescriptionForm.controls['wagesFrom'].touched && jobPositionDescriptionForm.controls['wagesFrom'].invalid">
        <span class="invalid-message" *ngIf="jobPositionDescriptionForm.controls['wagesFrom'].errors?.required">
          {{getGlobalErrorMessages('REQUIRED')}}
        </span>
        <span class="invalid-message" *ngIf="jobPositionDescriptionForm.controls['wagesFrom'].errors?.pattern">
          {{getGlobalErrorMessages('NUMBER_ONLY')}}
        </span>
      </div>
    </div>
    <div class="col-md-4 processing-dropdown">
      <label class="label-cls  required"> Wage Unit </label>
      <p-dropdown [options]="wageUnitType" [filter]="false" (onChange)="onWageUnitChange($event)" id="wageTypeCode"
        appendTo="body" formControlName="wageTypeCode" [disabled]="disabledControls" optionLabel="name"
        optionValue="code" placeholder="select">
      </p-dropdown>
      <div
        *ngIf="jobPositionDescriptionForm.controls['wageTypeCode'].touched && jobPositionDescriptionForm.controls['wageTypeCode'].invalid">
        <span class="invalid-message" *ngIf="jobPositionDescriptionForm.controls['wageTypeCode'].errors?.required">
          {{getGlobalErrorMessages('REQUIRED')}}
        </span>
      </div>
    </div>

    <div class="col-md-4 form-group input-disabled">
      <label class="label-cls required"> Annual Compensation </label>
      <span class="p-input-icon-left mask-input mw-100"> <i class="pi pi-dollar"></i>
        <input class="im-input mask-in mw-100" id="wagesPerYear" formControlName="wagesPerYear" type="text"
          [readonly]="disabledControls" pInputText placeholder="" /> </span>
    </div>
  </div> 
   <div class="row col-md-12 p-0">
    <lib-h1b-job-description style="width:100%" [parentForm]="jobPositionDescriptionForm" [disabledControls]="disabledControls"
      [beneficiaryId]="primaryData?.beneficiaryId" [isWizard]="isFromWizard" [petitionId]="primaryData?.petitionId">
    </lib-h1b-job-description>
  </div>

  <div class="row col-md-12">
    <h5 class="sub-title uploadLetter">Upload Offer Related Documents</h5>
  </div>
  <div class="row col-md-12 p-0">
    <file-upload-library style="width: 100%;" [fileUploadConfigurations]="fileUploadConfigurations">
    </file-upload-library>
  </div>
  <!-- <div class="row col-md-12 p-0">
    <job-duties-library style="width:100%" [disabledControls]="disabledControls" [inputData]="inputData"
      (deleteAllDutie)="handleDeleteAllDuties()" (addUpdateDuty)="handleAddUpdateDuty($event)"
      [parentForm]="jobPositionDescriptionForm" (deleteDuty)="handleDutyDelete($event)"
      (deleteSubDuty)="handleSubDutyDelete($event)"
      (onsaveJobRoleOrPopulateDuties)="handleOnsaveJobRoleOrPopulateDuties($event)">
    </job-duties-library>
  </div> -->
  <lib-custom-questionnaire *ngIf="!isFromWizard" [stepId]="primaryData.stepId" [taskId]="primaryData.taskId" [viewQuestions]="false"
    [showSaveBtn]="false" [loadedIn]="stepDetails.stepName" [isSection]="false"></lib-custom-questionnaire>
    <div class="row">
      <div class="col-md-9"></div>
    <div class="col-md-3 alignRight">
      <button pButton type="submit" label="{{isFromWizard ? 'Save':'Save & Continue'}}" title="Save"
        [ngClass]="jobPositionDescriptionForm.invalid  || disabledControls || !(jobPositionDescriptionForm.get('selectedRaiobtn').value === 0 ||(jobPositionDescriptionForm.get('selectedRaiobtn').value === 1 && (jobPositionDescriptionForm.get('jobRole').value && (jobPositionDescriptionForm.get('jobRole').value !== 'Other' || (jobPositionDescriptionForm.get('jobRole').value === 'Other' && jobPositionDescriptionForm.get('otherJobPosition').value)) && jobPositionDescriptionForm.get('duties').value && jobPositionDescriptionForm.get('duties').value.length > 0))) ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
        [disabled]="jobPositionDescriptionForm.invalid  || disabledControls || !(jobPositionDescriptionForm.get('selectedRaiobtn').value === 0 ||(jobPositionDescriptionForm.get('selectedRaiobtn').value === 1 && (jobPositionDescriptionForm.get('jobRole').value && (jobPositionDescriptionForm.get('jobRole').value !== 'Other' || (jobPositionDescriptionForm.get('jobRole').value === 'Other' && jobPositionDescriptionForm.get('otherJobPosition').value)) && jobPositionDescriptionForm.get('duties').value && jobPositionDescriptionForm.get('duties').value.length > 0)))"></button>
    </div>
    </div>
</form>
<p-divider></p-divider>